import { ExtensionInfo } from 'hooks/embedded-status/useEmbeddedStatusSwr';
import { useTranslation } from 'react-i18next';
import { hasOrderStatusPageMap } from '../../integrationStatusUtils';
import { SettingsWrapper } from '../../../settings-wrapper/SettingsWrapper';

export const OrderStatusPageMapIntegration = ({
    orderStatusPageMapIntegration,
    isLoading,
    condensed,
    handleClickAddStoreAppBlock,
}: OrderStatusPageMapIntegrationProps) => {
    const { t } = useTranslation();

    const hasOrderStatusPageMapIntegration = hasOrderStatusPageMap(orderStatusPageMapIntegration);

    const handleAddStoreAppBlock = () => {
        open(`shopify://admin/settings/checkout/editor?page=thank-you&context=apps`, '_blank');
        handleClickAddStoreAppBlock?.();
    };

    return (
        <SettingsWrapper
            title={t('DASHBOARD.APP_EXTENSIONS.ORDER_STATUS_PAGE_MAP_INTEGRATION.TITLE')}
            badge={
                <s-badge tone={hasOrderStatusPageMapIntegration ? 'success' : undefined}>
                    {hasOrderStatusPageMapIntegration
                        ? t('DASHBOARD.APP_EXTENSIONS.ACTIVE')
                        : t('DASHBOARD.APP_EXTENSIONS.INACTIVE')}
                </s-badge>
            }
            description={
                hasOrderStatusPageMapIntegration
                    ? t('DASHBOARD.APP_EXTENSIONS.ORDER_STATUS_PAGE_MAP_INTEGRATION.ACTIVE')
                    : t('DASHBOARD.APP_EXTENSIONS.ORDER_STATUS_PAGE_MAP_INTEGRATION.INACTIVE')
            }
            actions={
                <s-button variant="secondary" onClick={handleAddStoreAppBlock}>
                    {t('DASHBOARD.APP_EXTENSIONS.ORDER_STATUS_PAGE_MAP_INTEGRATION.ACTIONS.ADD_ORDER_STATUS_PAGE_MAP')}
                </s-button>
            }
            isLoading={isLoading}
            condensed={condensed}
        />
    );
};

interface OrderStatusPageMapIntegrationProps {
    orderStatusPageMapIntegration: ExtensionInfo;
    isLoading: boolean;
    condensed?: boolean;
    handleClickAddStoreAppBlock?: () => void;
}
